// extracted by mini-css-extract-plugin
module.exports = {"formCheckbox":"FormCheckbox_formCheckbox__1VTDG","permissionForm":"FormCheckbox_permissionForm__2d5X1","createAppForm":"FormCheckbox_createAppForm__dP3uM"};